import Flex from '@Components/Bases/Flex';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import { Box, Button, Typography } from '@mui/material';

interface SelectESGProps {
  reportId?: number;
}

const SelectESG = ({ reportId }: SelectESGProps): JSX.Element => {
  const navigateToESGPlans = (): void => {
    window.location.href = `/report/${reportId}/esg-plans`;
  };

  return (
    <Box>
      <Flex p={1} alignItems="center">
        <Flex p={1}>
          <AccessTimeFilledIcon
            sx={(theme) => ({
              color: theme.palette.secondary.lighter,
            })}
          />
        </Flex>
        <Box width={1}>
          <Flex justifyContent="space-between" alignItems="center">
            <Typography>กรุณาเลือกแผนการยกระดับ ESG Data Platform</Typography>
            <Button
              variant="text"
              color="info"
              onClick={navigateToESGPlans}
              sx={{ fontWeight: 400 }}
            >
              แก้ไขข้อมูล
            </Button>
          </Flex>
        </Box>
      </Flex>
    </Box>
  );
};

export default SelectESG;
